module.exports = __webpack_public_path__ + "img/guide-4.f3c1b7c6.png";